import { useQuery } from '@tanstack/react-query';
import { legacy } from '@/shared/api/client';

/** O que o usuário comum vê dos créditos de IA: só percentual, nunca tokens ou valores. */
export interface MyAiCredits {
  segmentationsAllowed: boolean;
  percentUsed: number;
  exhausted: boolean;
  renewMonthly: boolean;
  renewsAt: string | null;
}

export const myAiCreditsKey = (idPassbook: string) => ['ai-credits', 'me', idPassbook] as const;

export function useMyAiCredits(idPassbook: string | undefined, options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: myAiCreditsKey(idPassbook ?? ''),
    queryFn: async () => {
      const res = await legacy.get<{ data: MyAiCredits }>(
        `/ai-credits/me?idPassbook=${encodeURIComponent(idPassbook!)}`,
        { headers: { 'X-Passbook-Id': idPassbook! } },
      );
      return res.data;
    },
    staleTime: 60_000,
    enabled: (options?.enabled ?? true) && Boolean(idPassbook),
  });
}
